const VARIANTS = {
  primary:
    'bg-ocean-500 text-white hover:bg-ocean-600 shadow-sm shadow-ocean-200 hover:shadow-md hover:shadow-ocean-200',
  secondary: 'bg-slate-100 text-slate-700 hover:bg-slate-200',
  danger:
    'bg-red-500 text-white hover:bg-red-600 shadow-sm shadow-red-200 hover:shadow-md hover:shadow-red-200',
  ghost: 'text-slate-600 hover:bg-slate-100',
  success:
    'bg-emerald-600 text-white hover:bg-emerald-700 shadow-sm shadow-emerald-200 hover:shadow-md hover:shadow-emerald-200',
  violet:
    'bg-violet-600 text-white hover:bg-violet-700 shadow-sm shadow-violet-200 hover:shadow-md hover:shadow-violet-200',
  blue: 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm shadow-blue-200 hover:shadow-md hover:shadow-blue-200',
}

const SIZES = {
  sm: 'px-3 py-1.5 text-sm',
  md: 'px-4 py-2.5 text-sm',
  lg: 'px-6 py-3 text-base',
}

// Spring-ish easing: overshoots very slightly on release for a subtle
// bounce, matching the design system's "bounciness 4" spring spec.
const PRESS_TRANSITION =
  'transform 180ms cubic-bezier(0.34, 1.56, 0.64, 1), background-color 150ms ease, box-shadow 150ms ease'

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  className = '',
  style = {},
  ...props
}) {
  return (
    <button
      className={`font-medium rounded-xl whitespace-nowrap active:scale-[0.96] focus-visible:outline-none ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      style={{
        transition: PRESS_TRANSITION,
        ...style,
      }}
      onFocus={(e) => {
        e.currentTarget.style.boxShadow = 'var(--focus-ring)'
      }}
      onBlur={(e) => {
        // clear the focus ring but keep any variant shadow via className
        e.currentTarget.style.boxShadow = ''
      }}
      {...props}
    >
      {children}
    </button>
  )
}
